require('../../shared/teamLineup/teamLineupDirective');

"use strict";

angular.module('app.myHockeyTv.myGames', [
    'app.shared.teamLineup.teamLineupDirective'
])
    .config([
        '$stateProvider',
        function ($stateProvider) {
            $stateProvider.state('app.myHockeyTv.myGames', {
                url: '/my_games',
                templateUrl: 'components/myHockeyTv/myGames/myGamesView.html',
                subTitle: 'My Games',
                isChildState: true
            });
        }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/myHockeyTv/myGames/myGames.js